import { TextField as MuiTextField } from '@mui/material'
import type { FieldMeta } from '@crm/shared'

interface NumberFieldProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  hideLabel?: boolean
}

export function NumberField({ field, value, mode, onChange, error, disabled, hideLabel }: NumberFieldProps) {
  if (mode === 'view') {
    if (value == null) return <span />
    const num = Number(value)
    return <span>{isNaN(num) ? String(value) : num.toLocaleString()}</span>
  }

  return (
    <MuiTextField
      label={hideLabel ? undefined : field.label}
      type="number"
      value={value ?? ''}
      onChange={(e) => {
        const v = e.target.value
        onChange?.(v === '' ? undefined : Number(v))
      }}
      error={!!error}
      helperText={error}
      disabled={disabled}
      required={!!field.is_required}
      size="small"
      fullWidth
    />
  )
}
